export default __webpack_public_path__ + "static/media/sounds/daze_scroll_intro_alyx.mp3";